import { MODAL_CLOSE, MODAL_OPEN } from './constants'

export default function () {
  const initialState = {
    isShowAccountTakeOverPopup: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case MODAL_OPEN:
        return {
          ...state,
          isShowAccountTakeOverPopup: true,
        }
      case MODAL_CLOSE:
        return { ...state, isShowAccountTakeOverPopup: false }

      default:
        return state
    }
  }
}
